import { createContext } from 'react';
var initialContext = {
  showNotification: function showNotification(notification) {
    return null;
  }
};
export var NotificationsContext = createContext(initialContext);